<!-- Page banner Area -->
<div class="page-banner bg-3">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content">
                    <h2>Reset Password</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Reset Password</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page banner Area -->

<!-- Start Sign in Area -->
<div class="sign-in-area ptb-100">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10 col-xl-8">
                <div class="text-center mb-4">
                    <div class="fs-3 text-black fw-semibold mb-2">Reset your password</div>
                    <p class="text-muted mb-0">Create a new password for your account</p>
                </div>

                <div class="card auth-card">
                    <div class="card-body p-4 p-md-5">
                        <form [formGroup]="resetPasswordForm" #resetPasswordNgForm="ngForm">
                            <div class="mb-3">
                                <label for="password" class="form-label">Password <span class="text-danger">*</span></label>
                                <input type="password" class="form-control" id="password" [formControlName]="'password'"
                                    autocomplete="new-password" placeholder="Enter your password" name="password">
                                <div class="text-danger small mt-2" *ngIf="resetPasswordForm.controls['password'].invalid &&
                                                (resetPasswordForm.controls['password'].dirty ||
                                                    resetPasswordForm.controls['password'].touched || isSubmit)
                                            ">
                                    <span *ngIf="resetPasswordForm.controls['password'].errors.required">
                                        Please enter a password!
                                    </span>
                                    <span *ngIf="resetPasswordForm.controls['password'].errors?.minlength">
                                        Password must be at least 8 characters long.
                                    </span>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="password-confirm" class="form-label">Confirm Password <span class="text-danger">*</span></label>
                                <input type="password" class="form-control" id="password-confirm"
                                    [formControlName]="'passwordConfirm'" placeholder="Confirm your password" name="password-confirm">
                                <div class="text-danger small mt-2" *ngIf="resetPasswordForm.controls['passwordConfirm'].invalid &&
                                                (resetPasswordForm.controls['passwordConfirm'].dirty ||
                                                    resetPasswordForm.controls['passwordConfirm'].touched || isSubmit)
                                            ">
                                    <span *ngIf="resetPasswordForm.controls['passwordConfirm'].errors.required">
                                        Please enter a confirmation Password!
                                    </span>
                                </div>
                            </div>

                            <div class="text-center mb-4">
                                <button type="button" class="btn btn-blink" (click)="resetPassword()">
                                    <span>Reset your password</span>
                                    <i class="bi bi-arrow-right"></i>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Sign in  Area -->